import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import http from 'utils/axiosService';
import { domain } from 'config';

// Customizable logo/favicon (see util/Branding.cs). Falls back to the images bundled in public/ until the
// backend says a custom one has been uploaded.
export const DEFAULT_BRANDING = {
  logo: process.env.PUBLIC_URL + '/img/logo.png',
  favicon: process.env.PUBLIC_URL + '/favicon.ico'
};

const toUrls = (versions) =>
  Object.fromEntries(
    Object.entries(DEFAULT_BRANDING).map(([kind, fallback]) => [
      kind,
      versions?.[kind] ? `${domain}/api/public/branding/${kind}?v=${versions[kind]}` : fallback
    ])
  );

const BrandingContext = createContext({ ...DEFAULT_BRANDING, refresh: () => {} });

export const BrandingProvider = ({ children }) => {
  const [urls, setUrls] = useState(DEFAULT_BRANDING);

  const refresh = useCallback(
    () =>
      http
        .get(`${domain}/api/public/branding`)
        .then((res) => setUrls(toUrls(res.data)))
        .catch((error) => console.error('Failed to load branding', error)),
    []
  );

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = urls.favicon;
  }, [urls.favicon]);

  return <BrandingContext.Provider value={{ ...urls, refresh }}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
